import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

// utilities
import _ from 'lodash';
import cx from 'classnames';
import addPropsToChildren from '../../../lib/addPropsToChildren';
import { stripUnknownProps } from '../../../utils/reactProps';


@connect(store => ({
    scrollBarWidth: store.user.scrollBarWidth,
    wasNavigatedTo: store.routing.locationBeforeTransitions.action === 'PUSH'
}))
export default class Modal extends Component {
  static propTypes = {
    show: PropTypes.bool,
    onClose: PropTypes.func,
    children: PropTypes.any,
    className: PropTypes.string,
    modalClass: PropTypes.string,
    modalContentClass: PropTypes.string,
    scrollBarWidth: PropTypes.number,
    noScroll: PropTypes.bool,
    wasNavigatedTo: PropTypes.bool,
    fadeModal: PropTypes.bool,
    fadeModalChildren: PropTypes.bool,
    outsideUnclickable: PropTypes.bool,
    childAnimInit: PropTypes.object,
    childStyle: PropTypes.object,
    transitionDuration: PropTypes.number,
    floatDownModalChildren: PropTypes.bool,
    opacityTransitionIn: PropTypes.string,
    opacityTransitionOut: PropTypes.string,
    transformTransitionIn: PropTypes.string,
    transformTransitionOut: PropTypes.string
  }

  static defaultProps = {
    show: false,
    children: null,
    className: '',
    scrollBarWidth: 15,
    transitionDuration: 200,
    opacityTransitionIn: 'cubic-bezier(.02,.75,.41,.96)',
    opacityTransitionOut: 'cubic-bezier(.92,.18,.81,.77)',
    transformTransitionIn: 'cubic-bezier(.09,.6,.21,.97)',
    transformTransitionOut: 'cubic-bezier(.09,.77,.21,.97)'
  }

  state = {
    transitionHide: false,
    transitioning: false,
    isEdge: false
  }

  componentWillMount() {
    if(this.props.wasNavigatedTo && !this.state.transitionHide && (this.props.fadeModal || this.props.fadeModalChildren)) {
      this.setState(_.merge(this.state, {
        isEdge: navigator && (/Edge\/\d./i.test(navigator.userAgent)), // TEMP FIX FOR EDGE
        transitionHide: true,
        transitioning: true
      }));
      setTimeout(() => this.setState(_.merge(this.state, {
        transitionHide: false
      })));
      setTimeout(() => this.setState(_.merge(this.state, {
        transitioning: false
      })), this.props.transitionDuration);
    }
    else if(this.state.transitionHide || this.state.transitioning) {
      this.setState(_.merge(this.state, {
        isEdge: navigator && (/Edge\/\d./i.test(navigator.userAgent)), // TEMP FIX FOR EDGE
        transitionHide: false,
        transitioning: false
      }));
    }
  }

  closeModal(e) {
    if (this.props.onClose) {
      if(this.props.fadeModal || this.props.fadeModalChildren) {
        this.setState(_.merge(this.state, {
          transitionHide: true,
          transitioning: true
        }));
        setTimeout(() => {
          this.props.onClose(e);
        }, this.props.transitionDuration);
      } else {
        this.props.onClose(e);
      }
    }
  }

  hideOnOuterClick(e) {
		// only close outside of modal content is clicked
		if(e.target.dataset.modal) {
      this.closeModal(e);
		}
	}

  render() {
    const {
      show,
      className,
      modalClass,
      modalContentClass,
      onClose, // eslint-disable-line no-unused-vars
      children,
      scrollBarWidth,
      noScroll,
      fadeModal,
      fadeModalChildren,
      floatDownModalChildren,
      outsideUnclickable,
      childAnimInit,
      childStyle,
      transitionDuration,
      opacityTransitionIn,
      opacityTransitionOut,
      transformTransitionIn,
      transformTransitionOut,
      wasNavigatedTo,
      ...otherProps
    } = this.props;

    // stored for convenience
    const transformChildren = ''; // `translate3d(-50%,${floatDownModalChildren && (!show || this.state.transitionHide) && 'calc(-50% - 30px)' || '-50%'},0)`;
    const calcedShow = show && !this.state.transitionHide;

    const modalShowTransition = `opacity ${transitionDuration}ms ${opacityTransitionIn}, transform ${transitionDuration}ms ${transformTransitionIn}, visibility 0s 0s`;
    const modalFadeTransition = `opacity ${transitionDuration}ms ${opacityTransitionOut}, transform ${transitionDuration}ms ${transformTransitionOut}, visibility 0s ${transitionDuration}ms`;

    // only use scrollbar width if there is a scrollbar showing on the body
    const conditionalScrollbarWidth = !noScroll && scrollBarWidth || 0;

    return (
      <div className={`modal-container ${className}`} data-id='Modal'>
        <div className={cx('modal', modalClass, {'modal-fade': fadeModal, 'modal-show': calcedShow && fadeModal})}
             style={!calcedShow && fadeModal && {
               visibility: 'hidden',
               opacity: 0,
               transition: modalFadeTransition
             } || {
               transition: modalShowTransition
             }}
             onMouseDown={!outsideUnclickable && ::this.hideOnOuterClick}
             onTouchStart={!outsideUnclickable && ::this.hideOnOuterClick}
             data-modal='true'
             {...stripUnknownProps(otherProps)}>
        </div>
        <div className={cx('modal-content', 'clearfix', modalContentClass, {'modal-fade': !this.state.isEdge && fadeModalChildren, 'modal-show': !this.state.isEdge && calcedShow && fadeModalChildren})}
             style={!this.state.isEdge && !calcedShow && fadeModalChildren && _.merge({}, childStyle, {
               visibility: 'hidden',
               opacity: 0,
               transform: transformChildren,
               transition: modalFadeTransition
             }, childAnimInit) || _.merge(!this.state.transitioning && {
               transform: transformChildren,
             } || {}, childStyle, this.state.transitioning && {
               transition: modalShowTransition,
               transform: transformChildren,
             } || {})}
             >
          {
            children
            &&
            addPropsToChildren(children, {closeModal: this.props.onClose && ::this.closeModal})
          }
        </div>
        {
          show
          &&
          <style>
            {/* turn off scrolling when modal is open */}
            {
              `
              html, body{
                overflow: hidden;
              }
              body {
                padding-right: ${conditionalScrollbarWidth}px;
              }
              .modal {
                left: -${scrollBarWidth}px;
                width: calc(100% + ${conditionalScrollbarWidth}px);
              }
              `
            }
          </style>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/common/components/r_Modal/index.js